/**
 * 프로필 수정(/profile/edit) 전용 기본값.
 * API: GET/PATCH /api/v1/users/me/profile — {@link import('./schemas/user').UserProfileResponseDto}
 */
import { DEFAULT_PROFILE_IMAGE_URL } from '../config/media';
import type { UserProfileResponseDto } from './schemas/user';

export type ProfileEditGender = 'female' | 'male';

export type ProfileEditFormDefaults = {
  bio: string;
  gender: ProfileEditGender;
  /** 선호 장르 (모달에서 최대 3개) */
  genres: string[];
  /** 선호 악기 (모달에서 최대 3개) */
  instruments: string[];
  nickname: string;
  region: string;
};

export const PROFILE_EDIT_DEFAULTS: ProfileEditFormDefaults = {
  bio: '안녕하세요 뮤지션J 입니다.',
  gender: 'female',
  genres: ['밴드', '록/메탈'],
  instruments: ['기타'],
  nickname: '뮤지션J',
  region: '서울특별시',
};

/** 백엔드 프로필 DTO → 폼 기본값 (성별·region 매핑은 백엔드 enum과 합의) */
export function profileEditDefaultsFromUserProfile(dto: UserProfileResponseDto): ProfileEditFormDefaults {
  return {
    nickname: dto.nickname,
    bio: dto.bio,
    gender: 'female',
    genres: dto.genreIds?.length ? [...dto.genreIds] : [],
    instruments: dto.instrumentIds?.length ? [...dto.instrumentIds] : [],
    region: dto.regionLabel ?? dto.regionCode ?? '',
  };
}

export function formatProfileGenresDisplay(genres: string[]): string {
  if (genres.length === 0) {
    return '';
  }
  return `장르 : ${genres.join(', ')}`;
}

export function formatProfileInstrumentsDisplay(instruments: string[]): string {
  if (instruments.length === 0) {
    return '';
  }
  return `악기 : ${instruments.join(', ')}`;
}

export const PROFILE_EDIT_DEFAULT_PHOTO = DEFAULT_PROFILE_IMAGE_URL;
